<template>
  <div>
    <base-header class="pb-8 pt-4">
    </base-header>
    <div class="container-fluid mt--7">
      <h2>{{ $t("Kuaför Randevuları") }}</h2>
      <b-card>
        <div class="w-100 d-flex justify-content-center" v-if="loading">
          <b-spinner></b-spinner>
        </div>
        <template v-else>
          <!-- <b-row>
            <b-col sm="12" class="d-flex align-items-center justify-content-between">
              <div style="width: 200px">
              </div>
              <div style="width: 200px">
                <b-form-group>
                  <b-form-select v-model="employee" @change="loadData" :options="selectEmployees"></b-form-select>
                </b-form-group>
              </div>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col offset-md="6" class="mb-4">

              <b-form-input type="date" @change="gotoDate"/>
            </b-col>
            <b-col sm="12">
              <full-calendar ref="calendar" :options="calendar" @event-selected="onClickEvent"/>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </div>

    <!-- Create Appointment -->
    <b-modal ref="modal" title="Randevu Kaydı" @hide="resetCalendarModal">
      <b-form-group>
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Müşteri Seçimi") }} <span
            style="color:red">*</span></legend>
        <v-select v-model="calendarModal.client" :options="clients" @input="checkClient"></v-select>
      </b-form-group>


      <b-row>
        <b-col sm="8">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Başlangıç Tarihi") }} <span style="color:red">*</span>
            </legend>
            <b-form-input v-model="calendarModal.start_date" type="date"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Başlangıç Saati") }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.start_time" type="time"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>


      <b-row>
        <b-col sm="8">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Bitiş Tarihi") }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.end_date" type="date"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Bitiş Saati") }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.end_time" type="time"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>

          <b-form-group label="Açıklama">
            <b-textarea v-model="calendarModal.description"></b-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <!--      <b-form-group>-->
      <!--        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">İlgili Çalışan <span style="color:red">*</span></legend>-->
      <!--        <v-select v-model="calendarModal.employee" :options="employees" />-->
      <!--      </b-form-group>-->

      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="left">
            <b-form-checkbox v-model="calendarModal.sendSMS">{{ $t("Bildirim SMS'i Gönder") }}</b-form-checkbox>
          </div>
          <div class="right">
            <b-button @click="hideModal">İptal</b-button>
            <b-button variant="primary" @click="saveAppointment" class="loading-button"
                      :disabled="$v.$invalid || buttonLoading">
              <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t("Kaydet") }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <!--#Create Appointment -->

    <!-- Show Appointment -->
    <b-modal ref="showAppointmentModal" title="Randevu Detayı">
      <table class="table">
        <tr>
          <td>Müşteri</td>
          <td>{{ showEvent.client ? showEvent.client.full_name : 'Müşteri Silinmiş' }}</td>
        </tr>
        <tr v-if="showEvent.employee">
          <td>{{ $t("İlgili Calışan") }}</td>
          <td>{{ showEvent.employee.full_name }}</td>
        </tr>
        <tr>
          <td>{{ $t("Başlangıç Zamanı") }}</td>
          <td>{{ moment(showEvent.startDate).format('DD.MM.YYYY H:mm') }}</td>
        </tr>
        <tr>
          <td>{{ $t("Bitiş Zamanı") }}</td>
          <td>{{ moment(showEvent.endDate).format('DD.MM.YYYY H:mm') }}</td>
        </tr>
        <tr>
          <td>{{ $t("İlgili Hizmetler") }}</td>
          <td>{{ prepareServices(showEvent.services) }}</td>
        </tr>
      </table>

      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="left">
            <a href="#" @click.prevent="deleteAction">(X) {{ $t("Etkinliği Sil") }}</a>
          </div>
          <div class="right">
            <b-button variant="secondary" @click="$refs.showAppointmentModal.hide()">{{ $t("Kapat") }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <!--#Show Appointment -->

    <!-- Client Modal -->
    <b-modal
        ref="createClient"
        title="Müşteri Oluştur"
        @ok="saveClient"
        @hide="resetClientModal"
        ok-title="Kaydet"
        cancel-title="İptal"
    >
      <b-form-group label="Ad Soyad">
        <b-form-input v-model="clientModal.full_name"></b-form-input>
      </b-form-group>
      <b-form-group label="GSM">
        <b-form-input
            v-model="clientModal.gsm"
            v-mask="'+90 (###) ### ####'"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="E-mail">
        <b-form-input v-model="clientModal.email"></b-form-input>
      </b-form-group>
    </b-modal>
    <!--#Client Modal -->

    <!-- Service Modal -->
    <b-modal ref="createService" title="Yeni Ürün Oluştur" @hide="resetServiceModal">
      <b-row>
        <b-col>
          <b-form-group label="Başlık">
            <b-form-input v-model="serviceModal.name"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Barkod">
            <b-form-input v-model="serviceModal.barcode"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Birim">
            <b-form-select v-model="serviceModal.unit" :options="dependencies['units']"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__214__BV_label_">Stok <span
                style="font-size:12px">{{ $t("Limitsiz için") }} <b-badge variant="default">-1</b-badge> girin</span></legend>
            <b-form-input v-model="serviceModal.stock"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Marka">
            <b-form-select v-model="serviceModal.brand_id" :options="dependencies['product-brands']"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Kategori">
            <b-form-select v-model="serviceModal.category_id" :options="dependencies['product-categories']"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Alış Fiyatı">
            <b-form-input v-model="serviceModal.purchase_price"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Satış Fiyatı">
            <b-form-input v-model="serviceModal.price" type="number"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="KDV Oranı">
            <b-form-input v-model="serviceModal.tax" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <label class="d-flex-align-items-center">
        <switches v-model="serviceModal.included_tax" theme="custom" color="red"/>
        <span>Satış Fiyatına KDV Dahil</span>
      </label>

      <template v-slot:modal-footer>
        <div class="text-right">
          <b-button variant="secondary" @click="$refs.createService.hide()">{{ $t("İptal") }}</b-button>
          <b-button variant="primary" @click="saveService">{{ $t("Kaydet") }}</b-button>
        </div>
      </template>
    </b-modal>
    <!--#Service Modal -->

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import moment from 'moment'
import Switches from 'vue-switches'
import {required} from 'vuelidate/lib/validators'

// calendar view
// import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import timeGridPlugin from '@fullcalendar/timegrid'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import '@fullcalendar/core/locales/tr'
// import 'fullcalendar/dist/fullcalendar.css'

export default {
  name: 'CreateAppointment',
  components: {
    FullCalendar, Switches,
  },
  data() {
    return {
      dependencies: {},
      loading: true,
      buttonLoading: false,
      modalType: 'create',
      employee: 'all',
      calendarStyle: 'month',
      calendar: {

        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        },
        eventOverlap: false,
        plugins: [timeGridPlugin, interactionPlugin,dayGridPlugin],
        // initialView: 'timeGridWeek',
        initialView: 'timeGridDay',
        events: [],
        locale: 'tr',
        dateClick: this.onClickDay,
        allDaySlot: false,
        scrollTime: '07:00:00',
        height: 750,
        nowIndicator: true,
        firstDay: 1,
      },
      service: null,
      showEvent: {
        client: {
          full_name: ''
        },
        employee: {
          full_name: ''
        },
        services: [],
        startDate: '',
        endDate: '',
      },
      selectEmployees: [],
      calendarModal: {
        description: '',
        client: {},
        employee: {label: "Tüm Çalışanlar", value: "all"},
        services: [],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        sendSMS: false,
      },
      serviceModal: {
        name: "",
        price: 0,
      },
      clientModal: {
        full_name: "",
        gsm: "",
        email: ""
      },
      services: [],
      clients: [],
      employees: [],
    }
  },
  methods: {
    ...mapActions(['getCoiffeurAppointments', 'createCoiffeurAppointment', 'deleteCoiffeurAppointment', 'createClientVSelect']),
    gotoDate(date){
      this.$refs.calendar.getApi().gotoDate(date)
    },
    resetCalendarModal() {
      this.calendarModal = {
        client: {},
        employee: {label: "Tüm Çalışanlar", value: "all"},
        services: [],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        sendSMS: false,
        service: null,
      };
      this.service = null;
    },
    deleteAction() {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'Kayıt silinecektir, emin misiniz?'
      }).then(ok => {
        if (ok.value) {
          this.deleteAppointment(this.showEvent.id)
              .then(response => {
                this.success(response.data.message);
                this.$refs.showAppointmentModal.hide()
                location.reload()
              }).catch(err => {
            const error = err.message ? err.message : err.response.data;
            this.error(error);
          });
        }
      });
    },
    prepareServices(services) {
      let names = services.map(item => item.name)
      return names.join(', ')
    },
    moment(a = null) {
      return moment(a)
    },
    saveAppointment() {
      this.buttonLoading = true;
      this.createCoiffeurAppointment(this.calendarModal)
          .then(response => {
            this.success(response.data.message)
            this.buttonLoading = false;
            this.loadData();
            this.hideModal()
          }).catch(error => {
        this.error(error.response.data.message)
        this.buttonLoading = false;
      })
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    resetAppointment() {
      this.service = null
      this.calendarModal = {
        client: {},
        employee: {},
        services: [],
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        sendSMS: false,
      }
    },
    saveService() {
      // this.createServiceVSelect(this.serviceModal)
      //   .then(
      //     response => {
      //       this.services.push(response.data);
      //       this.calendarModal.services.push(response.data);
      //       this.service = {}
      //       this.success("Hizmet başarıyla oluşturuldu!");
      //       this.$refs.createService.hide();
      //     }
      //   );
    },
    resetServiceModal() {
      this.serviceModal = {
        name: "",
        price: ""
      };
    },
    checkService() {
      if (this.service) {
        if (this.service.value === "create_new") {
          this.$refs.createService.show();
        } else {
          this.calendarModal.services.push(this.service)
          this.service = {}
        }
      }
    },
    removeService(key) {
      this.calendarModal.services.splice(key, 1);
    },
    saveClient() {
      const request = {
        ...this.clientModal,
        type: "client"
      };
      this.createClientVSelect(request).then(response => {
        this.clients.push(response.data);
        this.calendarModal.client = response.data;
        this.success("Müşteri başarıyla oluşturuldu!");
      });
    },
    resetClientModal() {
      this.clientModal = {
        full_name: "",
        gsm: "",
        email: ""
      };
    },
    checkClient() {
      if (this.calendarModal.client && this.calendarModal.client.value === "create_new") {
        this.$refs.createClient.show();
      }
    },
    onClickDay: function (d) {
      const date = moment(d.date).format('YYYY-MM-DD');
      this.calendarModal.start_date = date;
      this.calendarModal.start_time = moment(d.date).format('HH:mm')
      this.calendarModal.end_date = date;
      this.modalType = 'create'
      this.$refs.modal.show()
    },
    onClickEvent(e) {
      this.modalType = 'edit'
      let event = this.calendar.events.find(s => s.id === e.id)
      this.showEvent = event
      this.$refs.showAppointmentModal.show()
      // console.log(`You clicked: ${e.title}`)
    },
    setShowDate(d) {
      this.calendar.showDate = d
    },
    loadData() {
      this.loading = true
      this.getCoiffeurAppointments({employee: this.employee})
          .then(json => json.data)
          .then(response => {
            this.appointments = response.appointments;
            this.calendar.events = response.appointments.map(item => {
              return {
                id: item.id,
                title: item.client ? item.client.full_name : 'Müşteri Silinmiş',
                start: item.start_time,
                end: item.end_time,
                client: item.client,
                employee: item.employee,
                services: item.services,
              }
            })

            this.clients = response.clients;
            this.clients.unshift({label: "Yeni Oluştur", value: "create_new"});

            // this.services = response.services;
            // this.services.unshift({ label: "Yeni Oluştur", value: "create_new" });

            this.employees = response.employees;
            this.employees.unshift({label: "Tüm Çalışanlar", value: "all"});

            this.dependencies = response.dependencies;

            this.selectEmployees = JSON.parse(JSON.stringify(this.employees)).map(item => {
              return {
                value: item.value,
                text: item.label,
              }
            })

            this.loading = false
          });
    }
  },
  async mounted() {
    await this.loadData();
    console.log(this.$refs)
    this.gotoDate('2010-01-01')

  },
  validations: {
    calendarModal: {
      client: {
        value: {required}
      },
      start_date: {required},
      start_time: {required},
      end_date: {required},
      end_time: {required},
    }
  },
}
</script>

<style scoped>
.fc-timegrid-event-harness {
  width: 10% !important;
}

.cv-day {
  cursor: pointer;
}

.cv-day:hover {
  background: rgba(217, 26, 26, 0.3);
}
</style>
